import ReportDashboard from "./../../components/dedicated/dashboard/Report";
import validatePerms from "utils/validate-perms";
import { PERMISSION } from "./../../constants/permission";

export default function Dashboard() {
	const canViewReport = validatePerms([PERMISSION.DASHBOARD.VIEW]);

	return <>{canViewReport && <ReportDashboard />}</>;
}
